module.exports = __webpack_public_path__ + "static/media/post-08.c898a3b1.png";